import React from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../actions/modalActions';
import close_gray from '../../../assets/close-large-gray.svg';
import close_magenta from '../../../assets/close-large-magenta.svg';
import './modalCloseButton.scss';


const ModalCloseButton = (props) => {
    const dispatch = useDispatch();

    return (
        <div id={props.placement} className='modal-close' onClick={() => dispatch(closeModal())}>
            <img className='close gray icon' src={close_gray} />
            <img className='close magenta icon' src={close_magenta} />
        </div>
    );
};

export default ModalCloseButton;